import React, { useState, useRef, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { Container, Row, Col, Form, Button, Alert, Dropdown, ButtonGroup, Card } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const BarcodePrintScreen = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialGtin = queryParams.get('gtin');
    const initialUpc = queryParams.get('upc');

    const isUpcMode = Boolean(initialUpc);
    const barcodeValue = initialUpc || initialGtin || '';
    const defaultFormat = isUpcMode ? 'UPC' : 'EAN13';
    const barcodeLabel = isUpcMode ? 'UPC' : 'GTIN';

    const [value, setValue] = useState(barcodeValue);
    const [format, setFormat] = useState(defaultFormat);
    const [width, setWidth] = useState(2);
    const [height, setHeight] = useState(100);
    const [displayValue, setDisplayValue] = useState(true);
    const canvasRef = useRef(null);
    const [error, setError] = useState('');

    useEffect(() => {
        if (canvasRef.current) {
            const ctx = canvasRef.current.getContext('2d');
            ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
            if (value) {
            try {
                JsBarcode(canvasRef.current, value, {
                    format: format,
                    width: parseFloat(width),
                    height: parseFloat(height),
                    displayValue: displayValue,
                    margin: 10,
                    background: "#ffffff",
                    lineColor: "#000000"
                });
                setError('');
            } catch (e) {
                    setError(`Invalid ${barcodeLabel} for ${format} format.`);
                }
            }
        }
    }, [value, format, width, height, displayValue]);

    const handlePrintBarcode = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Print Barcode</title></head><body>');
        printWindow.document.write('<img src="' + canvasRef.current.toDataURL("image/png") + '" />');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        
        // Delay the print dialog
        setTimeout(() => {
            printWindow.print();
        }, 100);
    };

    const handleSaveBarcode = () => {
        const url = canvasRef.current.toDataURL("image/png");
        const a = document.createElement('a');
        a.href = url;
        a.download = `${value}.png`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    return (
        <Container fluid className="px-4 py-4">
            <Row className="mb-3">
                <Col>
                    <h1>Print Barcode</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                        <canvas ref={canvasRef}></canvas>
                </Col>
            </Row>
            {error && (
                <div className="alert alert-dismissible alert-danger">
                    {error}
                </div>
            )}
            <Row>
                <div style={{ height: '50px' }}></div>
            </Row>
            <Card style={{ padding: '20px', marginBottom: '20px', maxWidth: '500px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                <Row className="mb-3">
                    <Col>
                        <h5>Barcode Settings</h5>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Form.Group controlId="formValue" style={{ maxWidth: '250px'}}>
                        <Form.Label>{barcodeLabel}</Form.Label>
                        <Form.Control
                            type="number"
                            min={0}
                            step={1}
                            placeholder={`Enter ${barcodeLabel}`}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            autoComplete="off"
                            spellCheck="false"
                        />
                    </Form.Group>
                    <Form.Group controlId="formFormat" style={{ maxWidth: '150px'}}>
                        <Form.Label>Barcode Format</Form.Label>
                        <Dropdown>
                            <Dropdown.Toggle variant="info" id="dropdown-basic">
                                {format}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setFormat('EAN13')}>EAN-13</Dropdown.Item>
                                <Dropdown.Item onClick={() => setFormat('UPC')}>UPC</Dropdown.Item>
                                <Dropdown.Item onClick={() => setFormat('CODE39')}>Code 39</Dropdown.Item>
                                <Dropdown.Item onClick={() => setFormat('CODE128')}>Code 128</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Form.Group>
                </Row>
                <Row className="mb-3">
                    <Form.Group controlId="formWidth" style={{ maxWidth: '100px' }}>
                        <Form.Label>Width</Form.Label>
                        <Form.Control
                            type="number"
                            min={1}
                            max={10}
                            step={1}
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                            autoComplete="off"
                            spellCheck="false"
                        />
                    </Form.Group>
                    <Form.Group controlId="formHeight" style={{ maxWidth: '100px' }}>
                        <Form.Label>Height</Form.Label>
                        <Form.Control
                            type="number"
                            min={40}
                            max={300}
                            step={10}
                            value={height}
                            onChange={(e) => setHeight(e.target.value)}
                            autoComplete="off"
                            spellCheck="false"
                        />
                    </Form.Group>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Form.Group controlId="formDisplayValue">
                            <Form.Check
                                type="checkbox"
                                label="Display Value Below Barcode"
                                checked={displayValue}
                                onChange={(e) => setDisplayValue(e.target.checked)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Card>

            <Row className="mb-3">
                <ButtonGroup className="gap-1" style={{ maxWidth: '340px' }}>
                    <Button variant="success" onClick={handleSaveBarcode}>
                        Save Barcode
                    </Button>
                    <Button variant="primary" onClick={handlePrintBarcode}>
                        Print Barcode
                    </Button>
                    <Button variant="secondary" onClick={() => window.history.back()}>
                        Cancel
                    </Button>
                </ButtonGroup>
            </Row>
        </Container>
    );
};

export default BarcodePrintScreen; 